module.exports = __webpack_public_path__ + "static/media/como-20.4e272804.jpg";